import { render, staticRenderFns } from "./OverviewPatent.vue?vue&type=template&id=45df57fc&scoped=true"
import script from "./OverviewPatent.vue?vue&type=script&lang=js"
export * from "./OverviewPatent.vue?vue&type=script&lang=js"
import style0 from "./OverviewPatent.vue?vue&type=style&index=0&id=45df57fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df57fc",
  null
  
)

export default component.exports